export default "__VITE_ASSET__CMPd3lsc__"